export enum TabVariant {
  DEFAULT = 'default',
  PILL = 'pill',
}
